import type { InspirationAdviceFilterAdviceCardContent } from '@eneco/cms-types/generated/InspirationAdviceFilterAdviceCard';
import type { InspirationAdviceFilterPhraseContent } from '@eneco/cms-types/generated/InspirationAdviceFilterPhrase';
import type { InspirationAdviceFilterTagContent } from '@eneco/cms-types/generated/InspirationAdviceFilterTag';
import type { InspirationAdviceFilterTipCardContent } from '@eneco/cms-types/generated/InspirationAdviceFilterTipCard';

/**
 * What a list item carries besides its fields: the Sitecore adapter keeps the item's `id` and `displayName`,
 * Sanity gives every array entry a `_key` and its `_type`. The generated types describe the fields only.
 */
type ItemMeta = { id?: string; _key?: string; _type?: string; displayName?: string };

export type AdviceFilterTag = InspirationAdviceFilterTagContent & ItemMeta;
type WithTags<T> = Omit<T, 'tagsList'> & ItemMeta & { tagsList?: AdviceFilterTag[] };

export type AdviceFilterCard =
  WithTags<InspirationAdviceFilterAdviceCardContent> | WithTags<InspirationAdviceFilterTipCardContent>;
export type AdviceFilterPhrase = WithTags<InspirationAdviceFilterPhraseContent>;

/** A stable React key for a list item on either lane. */
export const itemKey = (item: ItemMeta) => item.id ?? item._key;
